import React from 'react';
import classes from './Button.module.css';
const Button = props => {
    return(
        <button
        type={props.type}
        className={`${classes.button} ${props.className}`}
        onClick={props.onClick}
        value={props.value}
        >{props.children}</button>
    )
}

export default Button;